import {REFACTOR_API_URL} from '../../auth/constants';

export const addLeadImplant = (token: string, data: any) => {
  const ENDPOINT: RequestInfo = `${REFACTOR_API_URL}/lead-implantation`

  return  postData(token, ENDPOINT, data)
}

const postData = (token: string, endPoint: RequestInfo, object: object) => {
  const parameters: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: JSON.stringify(object),
  }
  
  let status = 0
  
  return fetch(endPoint, parameters)
      .then((response) => {
        status = response.status
        return response.json()
      })
      .then((data) => {
        return { data, status }
      })
      .catch((e) => {
        console.error(e)
      })
}
